export const animalFood = [
  {
    id: 'chicken-feed',
    name: 'Chicken Feed',
    animalId: 'chicken',
    plantsNeeded: 5, // e.g., 5 corn plants to make 1 feed
    productionPrice: {
      common: { sellingPrice: 18.3 },
      uncommon: { sellingPrice: 63 },
      rare: { sellingPrice: 91 },
      epic: { sellingPrice: 123 },
      legendary: { sellingPrice: 224 },
    },
  },
  {
    id: 'cow-feed',
    name: 'Chicken Feed',
    animalId: 'chicken',
    plantsNeeded: 5, // e.g., 5 corn plants to make 1 feed
    productionPrice: {
      common: { sellingPrice: 272 },
      uncommon: { sellingPrice: 466 },
      rare: { sellingPrice: 661 },
      epic: { sellingPrice: 855 },
      legendary: { sellingPrice: 1516 },
    },
  },
  {
    id: 'alpaga-feed',
    name: 'Chicken Feed',
    animalId: 'chicken',
    plantsNeeded: 5, // e.g., 5 corn plants to make 1 feed
    productionPrice: {
      common: { sellingPrice: 469 },
      uncommon: { sellingPrice: 863 },
      rare: { sellingPrice: 1334 },
      epic: { sellingPrice: 2194 },
      legendary: { sellingPrice: 3526 },
    },
  },
  // ... add food for other animals
];
